module.exports = __webpack_public_path__ + "img/andrew-ridley-jR4Zf-riEjI-unsplash.f20c74f3.jpg";